export default __webpack_public_path__ + "static/media/trigger.37aec6ab.png";